import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';


@Injectable()
export class Register {

    constructor(private http: HttpClient) { }

    save(account: any): Observable<any> {
        return this.http.post('api/register', account, {responseType: 'text'});
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/register/register.service.ts